/**
 * sessionStatus.js — session lifecycle status vocabulary and badge-class mapping.
 * Pure: no imports, no state, no React. Mirrors missionControl/domain/schema.js#statusPillClass.
 */

// Session lifecycle statuses. A session that leaves `deleting` is gone (no further status).
export const SESSION_STATUS = {
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed',
  DELETING: 'deleting'
};

// Shared copy for every control that goes dead because the session isn't open — the thread and chat
// Send buttons, the envelope Edit pencil, the debugger's New Execution card. Each of these used to
// carry its own hand-written variant ("…— reopen it to send messages" / "…to make changes" / "…to
// create new executions"); the tail only restated the label of the control being hovered, and four
// copies of one sentence drifted apart. One constant, one wording.
export const SESSION_CLOSED_HINT = "Session is closed";

export function isSessionOpen(session) {
  return !!(session && session.status === SESSION_STATUS.OPEN);
}

export function isSessionTransitioning(session) {
  return !!(session && (session.status === SESSION_STATUS.CLOSING || session.status === SESSION_STATUS.DELETING));
}

export function sessionStatusClass(status) {
  if (status === SESSION_STATUS.CLOSING || status === SESSION_STATUS.CLOSED || status === SESSION_STATUS.DELETING) {
    return 'title-tag-badge-muted';
  }
  // `open` and unknown/missing statuses both render as the steady-state (outlined teal) badge.
  return 'title-tag-badge';
}
